import { useEffect } from "react";
import { useParams } from "react-router";
import SettingsIcon from "@mui/icons-material/Settings";
import useSideScreen from "../../Layout/Hooks/useSideScreen";
import { Add, Delete, Edit, PlayArrow, Speed, Stop } from "@mui/icons-material";
import DataGridCard from "../analyse/DataGridCard";
import customToast from "../../genericComponents/CustomToast";
import { gql, useMutation } from "@apollo/client";
const Building = ({ setHeader }) => {
  const { openMutationSideScreen, openDeleteSideScreen } = useSideScreen();
  var params = useParams();
  useEffect(() => {
    setHeader({ icon: SettingsIcon, text: "i18n_menu_organizationmanagement" });
  }, [setHeader]);
  const defaultFilters = [
    { propertyName: "buildingId", comparator: "eq", value: params.id },
  ];

  const START_MUTATION=`mutation startTrackingEan($meterId:UUID!) {
  startTrackingEan(meterId:$meterId){
    isSuccess
    message    
  }
}`
const STOP_MUTATION=`mutation stopTrackingEan($meterId:UUID!) {
  stopTrackingEan(meterId:$meterId){
    isSuccess
    message    
  }
}`
const [startMeter, startGraphQlObj] = useMutation(gql(START_MUTATION),{
  refetchQueries:["meters"]
});

const [stopMeter, stopGraphQlObj] = useMutation(gql(STOP_MUTATION),{
  refetchQueries:["meters"]
});

  const getSelectedItemOptions = (item) => {
    if(!item) return [];
    
    return [
      {
        icon: Edit,
        name: "Edit",
        onClick: (item) => {
          openMutationSideScreen("updateMeter","meter", Speed, item);
        },
      },
      {
        icon: Delete,
        name: "Delete",
        onClick: (item) => {
          openDeleteSideScreen("meter", Speed, item);
        },
      },
      {
        icon: !item.isTracking?PlayArrow:Stop,
        name:!item.isTracking?"Start":"Stop",
        onClick: (item) => {
          if(!item.isTracking){
            startMeter({variables:{meterId:item.id}});
            customToast({type:"success",message:`Meter started`});
          }else {
            stopMeter({variables:{meterId:item.id}});
            customToast({type:"success",message:`Meter stopped`});
          }
          

        },
      },
    ];
  };
  return (
    <DataGridCard
      type="meters"
      icon={Speed}
      getSelectedItemOptions={getSelectedItemOptions}
      // multiSelectedItemOptions={multiSelectedItemOptions}
      title={params.name}
      mandatoryColumnNames="ean18 isTracking"
      defaultFilters={defaultFilters}
      toolbarOptions={[
        {
          icon: Add,
          name: "createMeterByEAN",
          onClick: () =>
            openMutationSideScreen("createMeterByEAN","meter", Add, {
              buildingId: params.id,
            }),
        },
      ]}
    />
  );
};
export default Building;
